function modal(
  title: string,
  content: string,
  actionContent: string,
  id: string,
  actionHandler: () => void,
  closeActionHandler: () => void
) {
  const existingModalEl = document.getElementById(id);

  if (existingModalEl) {
    return existingModalEl;
  }

  const modalEl: any = document.createElement('aab-modal');
  modalEl.setAttribute('modal-size', 'medium');
  modalEl.id = id;
  modalEl.innerHTML = `
        <h3 class="flex ai-center h3" slot="modal-title">
          ${title}
        </h3>
        <p slot="modal-content">${content}</p>
        <div class="flex jc-end" slot="modal-footer">
        </div>
      `;

  const buttonEl: any = document.createElement('aab-button');
  buttonEl.addEventListener('click', function () {
    modalEl.remove();
    actionHandler();
  });

  modalEl.addEventListener('modal-close', function () {
    modalEl.remove();
    closeActionHandler();
  });

  const footerEl = document.createElement('div');
  footerEl.setAttribute('slot', 'modal-footer');
  footerEl.className = 'flex jc-end';

  buttonEl.innerHTML = `
      <button>
        ${actionContent}
      </button>
      `;

  footerEl.insertAdjacentElement('beforeend', buttonEl);
  modalEl.insertAdjacentElement('beforeend', footerEl);
  document.body.insertAdjacentElement('beforeend', modalEl);

  return modalEl;
}

export default modal;
